import SpeciesManageSpeciesTrait from "./SpeciesManageSpeciesTrait";

export default SpeciesManageSpeciesTrait;
export { SpeciesManageSpeciesTrait };
